import { useMutation } from "react-query";

export default function useEmailLogin() {
  return useMutation({
    mutationFn: async (email: string) => {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/email-login`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email,
          }),
        },
      );

      if (!response.ok) throw new Error("Network response was not ok");

      return response.json();
    },
  });
}
